import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeGif = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M1.5 2.75h21m-21 18.5h21M16 17V9a2 2 0 0 1 2-2h2m-4 6h3m-7 4V7m-5 6h1v2a2 2 0 0 1-4 0V9a2 2 0 0 1 2-2h2"
	})
});
export default SvgKgCardTypeGif;
